import { Box, Button, Typography } from "@mui/material";
import PageLayout from "../../components/PageLayout/PageLayout";
import { styles } from "./styles";
import { useNavigate } from "react-router-dom";

export const SignUpSplash: React.FC = () => {
  const navigate = useNavigate();
  return (
    <>
      <PageLayout>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Box sx={styles.detailsContainer}>
            <Typography sx={{ marginTop: "20px" }} variant="h4">
              Congratulations!
            </Typography>
            <Typography sx={{ margin: "40px" }} variant="h5">
              OmMuse is providing 3 months of OmMuse Pro for free for the first
              100 users!
            </Typography>
            <Typography
              sx={{ marginTop: "20px", marginBottom: "40px" }}
              variant="subtitle1"
            >
              This includes discounts for Dolby.io AI Mastering and NFT minting
              (coming soon).
            </Typography>
            <Button onClick={() => navigate("/my-tracks")} sx={styles.button}>
              Continue
            </Button>
          </Box>
        </Box>
      </PageLayout>
    </>
  );
};
